import React from 'react';

const ProductUsageMetricsCards = ({ data, isLoading }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toLocaleString();
  };

  const formatDuration = (seconds) => {
    if (seconds >= 60) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}m ${secs}s`;
    }
    return `${Math.floor(seconds)}s`;
  };

  const cards = [
    {
      title: 'Total Page Views',
      value: data?.totalPageViews || 0,
      formatter: formatNumber
    },
    {
      title: 'Avg Page Views per User',
      value: data?.avgPageViewsPerUser || 0,
      formatter: (val) => parseFloat(val).toFixed(2)
    },
    {
      title: 'Avg Duration per Page',
      value: data?.avgDurationPerPage || 0,
      formatter: formatDuration
    }
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="p-4"
            style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
          >
            <div className="animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-8 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className="p-4"
          style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
        >
          <div className="flex flex-col items-center justify-center text-center">
            <div
              className="text-2xl font-semibold mb-1"
              style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
            >
              {card.formatter(card.value)}
            </div>
            <div
              className="text-xs"
              style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
            >
              {card.title}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductUsageMetricsCards;

